import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { CommonResponse } from '../models/common.model';
import { ChangePasswordPayload, ForgotPayload, LoginPayload, LoginResponse, logoutResponse, ResetPasswordPayload, ResetPasswordResponse, SetPasswordPayload, VerifyOtpPayload, VerifyOtpResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  emailSubject: BehaviorSubject<ForgotPayload | null> =
    new BehaviorSubject<ForgotPayload | null>(null);

  profileDetails: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);

  resetTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  FCMtoken: BehaviorSubject<any | null> = new BehaviorSubject<any | null>(null);

  deviceTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('test');

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();
  toggleSidebarView(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  constructor(
    private readonly http: HttpClient,
    private _translateService: TranslateService
  ) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginUser(loginDetails: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${environment.base_url}vendor/login`, loginDetails)
      .pipe(map(res => res.data));
  }


  forgotPassword(email: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}vendor/forgotPassword`,
      email
    );
  }

  verifyOtp(otp: VerifyOtpPayload): Observable<VerifyOtpResponse> {
    return this.http
      .post<{
        data: VerifyOtpResponse;
      }>(`${environment.base_url}vendor/verifyForgotPass`, otp)
      .pipe(map(res => res.data));
  }

  resetPassword(data: ResetPasswordPayload): Observable<ResetPasswordResponse> {
    return this.http
      .post<ResetPasswordResponse>(`${environment.base_url}vendor/resetPassword`, data)
      .pipe(map(res => res));
  }

  setPassword(data: SetPasswordPayload): Observable<ResetPasswordResponse> {
    return this.http
      .post<ResetPasswordResponse>(`${environment.base_url}vendor/setPassword`, data)
      .pipe(map(res => res));
  }

  getProfile(): Observable<LoginResponse> {
    return this.http
      .get<{ data: LoginResponse }>(`${environment.base_url}vendor/getProfile`)
      .pipe(map(res => res.data));
  }

  updateProfile(data: LoginResponse): Observable<LoginResponse> {
    return this.http
      .put<{
        data: LoginResponse;
      }>(`${environment.base_url}vendor/updateProfile`, data)
      .pipe(map(res => res.data));
  }

  updateAlternateEmail(data: any): Observable<any> {
    return this.http
      .put<{
        data: any;
      }>(`${environment.base_url}vendor/updateSubVendorProfile`, data)
      .pipe(map(res => res.data));
  }

  changePassword(data: ChangePasswordPayload): Observable<CommonResponse> {
    return this.http
      .post<CommonResponse>(`${environment.base_url}vendor/changePassword`, data)
      .pipe(map(res => res));
  }

  logout(): Observable<logoutResponse> {
    return this.http.get<logoutResponse>(`${environment.base_url}vendor/logout`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logoutAlert(): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translateService.instant('AreYouSure'),
        text: this._translateService.instant('Youwillbeloggedout'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this._translateService.instant('Cancel'),
        confirmButtonColor: '#ffaf18',
        cancelButtonColor: '#000',
        confirmButtonText: this._translateService.instant('Logout')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  passwordChangedLogout(): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translateService.instant('PasswordUpdatedSuccessfully'),
        text: this._translateService.instant('Youwillbeloggedout'),
        icon: 'success'
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  getPushNotifications(query?: string): Observable<any> {
    return this.http
      .get<{ data: any }>(`${environment.base_url}vendor/getNotifications?${query}`)
      .pipe(map(res => res.data));
  }
}
